__turbopack_context__.v({
  "active": "eventNavigation-module-scss-module__pfIM3G__active",
  "bottom": "eventNavigation-module-scss-module__pfIM3G__bottom",
  "chevron": "eventNavigation-module-scss-module__pfIM3G__chevron",
  "close": "eventNavigation-module-scss-module__pfIM3G__close",
  "event_details": "eventNavigation-module-scss-module__pfIM3G__event_details",
  "event_details_header": "eventNavigation-module-scss-module__pfIM3G__event_details_header",
  "hasHoverBg": "eventNavigation-module-scss-module__pfIM3G__hasHoverBg",
  "hiding": "eventNavigation-module-scss-module__pfIM3G__hiding",
  "hoverBg": "eventNavigation-module-scss-module__pfIM3G__hoverBg",
  "hoverLink": "eventNavigation-module-scss-module__pfIM3G__hoverLink",
  "li": "eventNavigation-module-scss-module__pfIM3G__li",
  "line_1": "eventNavigation-module-scss-module__pfIM3G__line_1",
  "line_2": "eventNavigation-module-scss-module__pfIM3G__line_2",
  "link": "eventNavigation-module-scss-module__pfIM3G__link",
  "list": "eventNavigation-module-scss-module__pfIM3G__list",
  "nav": "eventNavigation-module-scss-module__pfIM3G__nav",
  "noTitle": "eventNavigation-module-scss-module__pfIM3G__noTitle",
  "oaf10": "eventNavigation-module-scss-module__pfIM3G__oaf10",
  "overlay": "eventNavigation-module-scss-module__pfIM3G__overlay",
  "overlayContainer": "eventNavigation-module-scss-module__pfIM3G__overlayContainer",
  "span": "eventNavigation-module-scss-module__pfIM3G__span",
  "sub_link": "eventNavigation-module-scss-module__pfIM3G__sub_link",
  "submenu_list": "eventNavigation-module-scss-module__pfIM3G__submenu_list",
  "toggle": "eventNavigation-module-scss-module__pfIM3G__toggle",
  "top": "eventNavigation-module-scss-module__pfIM3G__top",
  "version-2026": "eventNavigation-module-scss-module__pfIM3G__version-2026",
  "version-2027": "eventNavigation-module-scss-module__pfIM3G__version-2027",
  "visible": "eventNavigation-module-scss-module__pfIM3G__visible",
  "wrapper": "eventNavigation-module-scss-module__pfIM3G__wrapper",
});
